const dummyEvents = [
    {
      id: '1',
      title: 'IoT Line Fair',
      description: `İlk olarak 2015 yılında organize edilen IoT Line Fair, Internet of Things teknolojisinin yaygınlaşmasına katkıda bulunmak, sektörün önde gelen şirketleri ile Start-Up’ları bir araya getirmek, kaliteli bir network ortamı sağlamak için düzenlenmiştir. 2015 yılını takiben her sene gerçekleştirilmeye başlanan ve günümüzde öğrenci organizasyonu olarak en büyük Nesnelerin İnterneti ve Akıllı Ürünler Fuarı olan IoT Line Fair, vizyonunu genişleterek IoT’nin ülkemizdeki nabzını tutmakta, öğrencilere, mühendislere ve iş adamlarına ilham kaynağı olmaktadır.`,

      purpose: `Etkinlik ile IoT teknolojisinin alanda çalışma yapan şirketlere, mühendislere, mühendis adaylarına ve ilgili herkese tanıtılmasının yanı sıra kariyerlerine farklı alanlarda yol gösterebilecek uzmanlarla bir araya getirilmesi,  
      
      Sektörün önde gelen şirketleri ve konuşmacıların oturumlarına katılma ve birebir soru sorma, Internet of Things çözümleri üzerine uygulama yapabilecek üniversite öğrencilerinin ve bireylerin teşvik edilmesi, onlara ilham kaynağı olması amaçlanmaktadır.`,

      mainPhoto: 'https://istanbul.eestec.net/img/photos/deneme.jpg',
      photos: [
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
      ],
      sponsors: [
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
    
    ],
    },
    {
      id: '2',
      title: 'EESTech Challange',
      description: `EESTech Challenge (EESTEC Technology Challenge), öğrencilerin EESTEC aracılığıyla
      düzenlenlediği uluslararası yarışmadır. Avrupalı öğrencilerin Elektrik Mühendisliği ve
      Bilgisayar Bilimi (EECS) alanında bilgi edinmeleri ve profesyonel ağlar geliştirmeleri için fırsatlar yaratmayı amaçlayan bir hackathondur.`,
      purpose: '',
      mainPhoto: 'https://istanbul.eestec.net/img/photos/deneme.jpg',
      photos: [
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
      ],
      sponsors: [
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
    
    ],
    },

    {
      id: '3',
      title: 'Soft Skills Academy',
      description: `SSA (Soft Skills Academy), EESTEC tarafından 2010’dan beri düzenlenen ve Avrupa’nın çeşitli yerlerinde uygulanan uluslararası bir projedir ve amacı öğrencilerin Soft Skills adı altında belirli yeteneklerini geliştirmektir. 2013’ten bu yana EESTEC LC Istanbul bünyesinde düzenlenen SSA etkinlikleri, İstanbul ve çevresinde yaşayan/okuyan pek çok öğrenciyi bu alanda uzman kişilerle buluşturarak öğrencilerin sosyal becerilerini geliştirmesine fırsat sunmuştur.  Alanında uzman bu kişilerin arasında, zamanında EESTEC’te tecrübe edinmiş ve belirli mevkilerde görev yapmış EESTEC eğitmenleri de bulunmaktadır. Etkinliğimize 2013'ten beri 500+ katılımcının katılımı ve 70+ eğitmenin katılımıyla gerçekleşmiştir.`,
      purpose: '',
      mainPhoto: 'https://istanbul.eestec.net/img/photos/deneme.jpg',
      photos: [
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
      ],
      sponsors: [
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
    
    ],
    },

    {
      id: '4',
      title: 'Uni-Day',
      description: 'Dil Okulları, Work and Travel ve Yurt dışı Stajları gibi yurt dışı fırsatları hakkında başta İTÜ olmak üzere üniversite öğrencilerini bilgilendirmek amacıyla alanında uzman şirketler ile buluşturan İTÜ’nün bu alandaki tek ve en büyük etkinliğidir.',
      purpose: 'Etkinliğimiz, öğrencilere kendilerini geliştirebilecekleri yollarla yurtdışı kapısı açarken hem ufuklarını açmalarını, hem vizyon sahibi olmalarını hem de kafalarındaki soru işaretlerini gidermelerini hedeflemektedir.Etkinlik öğrencilerle Yurtdışı Gençlik Kampları, Avrupa Gönüllü Hizmeti (AGH), Yaz Okulları, Dil Okulları, Interrail, Work and Travel, Work and Study, Exchange Programları, Yurtdışı Stajları ve Yüksek Lisans gibi yurt dışı olanakları sunan firmaların buluşturulması amacıyla gerçekleşmektedir. Bu firmalar üniversitemizin sağladığı stantlarda ve isteğe bağlı olarak yapacakları sunumlarda kendilerini tanıtma fırsatı bulacaklardır.',
      mainPhoto: 'https://istanbul.eestec.net/img/photos/deneme.jpg',
      photos: [
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
      ],
      sponsors: [
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
    
    ],
    },

    {
      id: '5',
      title: 'Start-IT-Up',
      description: 'EESTEC LC Istanbul IT Takımı tarafından gerçekleştirilen yazılım ve teknoloji odaklı START- IT-UP etkinliği, girişimcilik ekosistemiyle benzerlik göstererek mühendislik öğrencilerinin sadece teknik bilgi ve pratikte değil, aynı zamanda girişimcilikle ilgili de bilgi ve deneyim kazandırmayı amaçlıyor. Ayrıca, mühendislik öğrencilerine sektör dinamiklerini anlama, başarılı girişimcilerden öğrenme ve bu girişimcilerle bağlantılar oluşturma fırsatını da sunmaya devam etmektedir.',
      purpose: '',
      mainPhoto: 'https://istanbul.eestec.net/img/photos/deneme.jpg',
      photos: [
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
      ],
      sponsors: [
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
        "https://istanbul.eestec.net/img/photos/deneme.jpg",
    
    ],
    },
    // Add more entries as needed
  ];
  
  export default dummyEvents;
  